import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaUserShield, FaCheckCircle, FaSearch, FaClock } from 'react-icons/fa';
import '../../../../assets/css/general/footer/FeaturesDetail.css';

const AdminVerification = () => {
  return (
    <div className="feature-detail-page">
      <div className="feature-detail-container">
        <Link to="/" className="back-button">
          <FaArrowLeft /> Back to Home
        </Link>

        <div className="feature-header">
          <div className="feature-icon-large">
            <FaUserShield />
          </div>
          <h1 className="feature-title">Admin Verification System</h1>
          <p className="feature-subtitle">
            Ensuring authenticity and trust through rigorous verification processes
          </p>
        </div>

        <div className="feature-content">
          <section className="feature-section">
            <h2>Overview</h2>
            <p>
              Our Admin Verification System is the backbone of trust in our platform. 
              Every student request, NGO partner, and donor goes through a comprehensive 
              verification process to ensure legitimacy and prevent fraud.
            </p>
          </section>

          <section className="feature-section">
            <h2>Verification Process</h2>
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">1</div>
                <h3>Document Review</h3>
                <p>Our admin team carefully reviews all submitted documents for authenticity.</p>
              </div>
              <div className="step-card">
                <div className="step-number">2</div>
                <h3>Background Check</h3>
                <p>Comprehensive background verification through trusted third-party services.</p>
              </div>
              <div className="step-card">
                <div className="step-number">3</div>
                <h3>NGO Validation</h3>
                <p>Partner NGOs provide additional validation and local verification.</p>
              </div>
              <div className="step-card">
                <div className="step-number">4</div>
                <h3>Final Approval</h3>
                <p>Senior admin team provides final approval before going live.</p>
              </div>
            </div>
          </section>

          <section className="feature-section">
            <h2>What We Verify</h2>
            <div className="features-list">
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Identity Verification</h4>
                  <p>National ID cards, student IDs, and other official documents</p>
                </div>
              </div>
              <div className="feature-item">
                <FaSearch className="feature-check" />
                <div>
                  <h4>Educational Records</h4>
                  <p>Academic transcripts, enrollment certificates, and institution validation</p>
                </div>
              </div>
              <div className="feature-item">
                <FaClock className="feature-check" />
                <div>
                  <h4>Financial Need</h4>
                  <p>Income certificates, family financial status, and genuine need assessment</p>
                </div>
              </div>
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Address Verification</h4>
                  <p>Physical address confirmation through local NGO partners</p>
                </div>
              </div>
            </div>
          </section>

          <section className="feature-section cta-section">
            <h2>Trust Through Transparency</h2>
            <p>Our verification system ensures that every donation reaches deserving students.</p>
            <button className="cta-button">Learn More</button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AdminVerification;